import { makeStyles } from '~styles';

export const useStyles = makeStyles()(({ palette }) => ({
	root: {},
	gutterGroupSeparator: {
		borderTop: `1px solid ${palette.gray[300]}`,
	},
}));
